import { EMPTY_STRING } from '../../constants/common'

/**
 * Maximum allowed length
 */
export const SEARCH_TEXT_MAX_LENGTH = 256

/**
 * Minimum allowed length
 */
export const SEARCH_TEXT_MIN_LENGTH = 3

/**
 * Search timeout to wait value change
 */
export const SEARCH_TIMEOUT = 500

/**
 * Default search value
 * @type {SearchValue}
 */
export const EMPTY_SEARCH_VALUE = {
  archived: false,
  text: EMPTY_STRING,
  type: null,
}

/**
 * @type {SearchConfigs}
 */
export const EMPTY_SEARCH_CONFIGS = new Map([])

/**
 * Sentinel for an unset previous search API (distinguishes "not yet compared"
 * from a real `null` search API)
 */
export const SEARCH_API_UNSET = Symbol('unset')
